export function normaliseMyShowSlug(slug) {
  if (typeof slug !== "string") return null;

  const normalisedSlug = slug.trim();
  return normalisedSlug.length > 0 ? normalisedSlug : null;
}

export function normaliseMyShowSlugs(slugs) {
  if (!Array.isArray(slugs)) return [];

  return slugs
    .map(normaliseMyShowSlug)
    .filter((slug) => slug !== null);
}

export function normaliseMyShowState(state = {}) {
  return {
    myShowbags: normaliseMyShowSlugs(state.myShowbags),
    myRides: normaliseMyShowSlugs(state.myRides),
    myEvents: normaliseMyShowSlugs(state.myEvents),
    myFood: normaliseMyShowSlugs(state.myFood),
  };
}
